// utils/env.ts

export const isProduction = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  const hostname = window.location.hostname;
  return (
    hostname.includes('vercel.app') || 
    hostname.includes('qhome.vn') || 
    hostname.includes('run.app') ||
    hostname.includes('io.vn')
  );
};
